import { Vue, Component, Prop } from 'vue-property-decorator';
import * as mws from '@/shared/MwsViewModels';
import template from './usm-charges-panel.vue';
import TabContainer, { TabViewModel } from '../../tab-container/TabContainer';

@Component({
  mixins: [template],
  components: {
    TabContainer,
  },
})
export default class UsmChargesPanel extends Vue {s
  @Prop()
  data: mws.UsmChargesPanel;

  get containerTabs(): TabViewModel[] {
    return this.data.tabs
      .map((tab) => ({ heading: tab.heading, tableData: tab.tableData }));
  }

}
